// extracted by mini-css-extract-plugin
export default {"maincontainer":"Myplants_maincontainer__J1dN-","heading":"Myplants_heading__A28m3","table":"Myplants_table__qN9dF","th":"Myplants_th__q9GwO","td":"Myplants_td__t4G4t"};